import { Component, OnInit, ViewEncapsulation, Directive  } from '@angular/core';


@Component({
    selector: 'app-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    styleUrls: ['./loading-indicator.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true
})
export class LoadingIndicatorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
